import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import('@/views/layout/index.vue'), // 布局组件
    meta: { hidden: true },
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import("@/views/home/index.vue"),
        name: 'homeIndex',
        meta: { title: '首页' }
      },
      {
        path: '/product',
        component: () => import("@/views/product/index.vue"),
        name: 'productIndex',
        meta: { title: '产品' }
      },
      {
        path: '/productDetail',
        component: () => import("@/views/productDetail/index.vue"),
        name: 'productDetailIndex',
        meta: { title: '产品详情' }
      },
      {
        path: '/application',
        component: () => import("@/views/application/index.vue"),
        name: 'applicationIndex',
        meta: { title: '行业应用' }
      },
      {
        path: '/applicationDetail',
        component: () => import("@/views/applicationDetail/index.vue"),
        name: 'applicationDetailIndex',
        meta: { title: '行业应用详情' }
      },
      {
        path: '/contact',
        component: () => import("@/views/contact/index.vue"),
        name: 'contactlIndex',
        meta: { title: '客户案例' }
      },
      {
        path: '/contactDetail',
        component: () => import("@/views/contactDetail/index.vue"),
        name: 'contactDetaillIndex',
        meta: { title: '客户案例详情' }
      },
      {
        path: '/case',
        component: () => import("@/views/case/index.vue"),
        name: 'caseIndex',
        meta: { title: '公司新闻' }
      },
      {
        path: '/caseDetail',
        component: () => import("@/views/caseDetail/index.vue"),
        name: 'caseDetailIndex',
        meta: { title: '公司新闻详情' }
      },
      {
        path: '/about',
        component: () => import("@/views/about/index.vue"),
        name: 'aboutIndex',
        meta: { title: '关于我们' }
      },
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  routes,
});
export default router;